var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 24,
    viewBox: "0 0 160 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26712 12.3083L0.38916 1.04492H6.49724L6.52338 1.04628L12.4006 12.3083H6.26712Z",
    fill: "#49AA7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87796 23.572L0 12.3086H6.10805L6.13422 12.31L12.0115 23.572H5.87796Z",
    fill: "url(#paint0_linear_2121_100846)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1182 11.6921L19.2402 0.428711H25.3483L25.3745 0.430072L31.2517 11.6921H25.1182Z",
    fill: "url(#paint1_linear_2121_100846)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1294 0.430311L19.1789 0.427734H25.2462L11.8836 23.5723H5.76831L19.1294 0.430311Z",
    fill: "#5AE2A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6714 22.9538L18.7935 11.6904H24.9015L24.9277 11.6918L30.8049 22.9538H24.6714Z",
    fill: "#49AA7C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2105 18.472C49.4414 18.472 51.8034 17.1597 51.8034 14.4603C51.8034 12.5669 50.6411 11.5171 48.3166 10.5798L47.4167 10.2236C45.9545 9.66118 45.5608 9.11753 45.5608 8.42392C45.5608 7.54283 46.2732 7.07417 47.2293 7.07417C48.2041 7.07417 48.9352 7.59907 49.4976 8.66762L51.4097 7.59907C50.8098 6.19309 49.4226 4.78711 47.1355 4.78711C44.886 4.78711 43.0301 6.17434 43.0301 8.40517C43.0301 10.4298 44.5298 11.4421 46.3482 12.1732L47.1918 12.4919C48.5415 13.0355 49.1227 13.4667 49.1227 14.4415C49.1227 15.6038 48.2228 16.1474 47.173 16.1474C45.8233 16.1474 44.9797 15.2289 44.6048 14.1978L42.5239 15.1539C42.9926 17.1035 44.886 18.472 47.2105 18.472Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9316 4.97457H53.2262V18.2845H55.7945V14.0103H57.9316C60.8185 14.0103 62.6932 12.2107 62.6932 9.49246C62.6932 6.77423 60.8185 4.97457 57.9316 4.97457ZM57.7066 11.6483H55.7945V7.33662H57.7066C59.0939 7.33662 60.0874 7.95526 60.0874 9.49246C60.0874 11.0484 59.0939 11.6483 57.7066 11.6483Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6083 18.2845H74.3827L69.2462 4.97457H66.528L61.4102 18.2845H64.1847L65.0658 15.885H70.7272L71.6083 18.2845ZM65.9281 13.5229L67.8965 8.16147L69.8649 13.5229H65.9281Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0995 18.472C82.9179 18.472 85.0925 17.8346 86.4985 15.585L84.6239 14.2915C83.7615 15.5288 82.5243 16.035 81.1933 16.035C78.8312 16.035 76.8628 14.3478 76.8628 11.6296C76.8628 8.93007 78.8125 7.22414 81.1745 7.22414C82.468 7.22414 83.7615 7.7303 84.6239 8.96756L86.4985 7.67406C85.0925 5.42449 82.9179 4.78711 81.0995 4.78711C77.369 4.78711 74.2383 7.48659 74.2383 11.6296C74.2383 15.7725 77.3502 18.472 81.0995 18.472Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5779 15.9225V12.7543H94.7583V10.4298H90.5779V7.33662H95.5457V4.97457H88.0096V18.2845H95.7144V15.9225H90.5779Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.114 10.8609C105.014 10.4673 105.858 9.5487 105.858 8.18021C105.858 6.38055 104.452 4.97457 102.202 4.97457H97.3279V18.2845H102.09C105.108 18.2845 106.701 16.6911 106.701 14.3665C106.701 12.3419 105.464 11.2171 104.114 10.8609ZM101.658 7.22414C102.802 7.22414 103.383 7.74904 103.383 8.66762C103.383 9.52995 102.821 10.1486 101.696 10.1486H99.8962V7.22414H101.658ZM101.94 16.035H99.8962V12.1357H101.902C103.439 12.1357 104.152 12.9418 104.152 14.1041C104.152 15.2851 103.439 16.035 101.94 16.035Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.513 18.2845H118.25L115.138 13.448C116.675 12.7918 117.594 11.4046 117.594 9.49246C117.594 6.77423 115.719 4.97457 112.888 4.97457H108.221V18.2845H110.789V13.8791H112.776L115.513 18.2845ZM110.789 7.33662H112.626C114.032 7.33662 114.988 7.95526 114.988 9.49246C114.988 11.0484 114.032 11.6483 112.626 11.6483H110.789V7.33662Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M119.589 18.2845H122.158V4.97457H119.589V18.2845Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.056 18.2845H128.874C132.548 18.2845 135.304 15.5476 135.304 11.6296C135.304 7.71155 132.548 4.97457 128.874 4.97457H124.056V18.2845ZM126.624 15.8662V7.39286H128.78C131.311 7.39286 132.623 9.11753 132.623 11.6296C132.623 14.1416 131.311 15.8662 128.78 15.8662H126.624Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.564 11.1234H143.884V13.2792H147.071C146.677 15.3413 145.196 16.1099 143.565 16.1099C141.147 16.1099 139.253 14.3478 139.253 11.6296C139.253 8.89258 141.184 7.22414 143.565 7.22414C144.915 7.22414 146.171 7.7303 147.052 8.96756L148.908 7.67406C147.502 5.42449 145.308 4.78711 143.527 4.78711C139.778 4.78711 136.629 7.48659 136.629 11.6296C136.629 15.7725 139.759 18.472 143.452 18.472C147.127 18.472 150.164 15.735 149.564 11.1234Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.92 15.9225V12.7543H158.101V10.4298H153.92V7.33662H158.888V4.97457H151.352V18.2845H159.057V15.9225H153.92Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2121_100846",
    x1: 6.00574,
    y1: 12.3086,
    x2: 6.00574,
    y2: 23.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AE2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52AE82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2121_100846",
    x1: 25.246,
    y1: 0.428711,
    x2: 25.246,
    y2: 11.6921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AE82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AE2A1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.7beb16119f59eb47b70e06cccdf17585.svg";
export { ForwardRef as ReactComponent };